export const ORGANISM_TEST_IDS = {
    CODE_VIEWER_TID: {
        COPY_BTN: 'code-viewer-copy-btn',
        FULL_SCREEN_BTN: 'code-viewer-full-screen-btn',
        EXPAND_BTN: 'code-viewer-expand-btn',
        EDITABLE_TEXTAREA: 'code-viewer-editable-textarea',
        EDITABLE_TEXTAREA_FULLSCREEN: 'code-viewer-editable-textarea-fullscreen',
        VIEW_PAYLOAD_BTN: 'view-payload-btn',
    },
    EXPORT_MODAL_TID: {
        FORMAT: 'export-format',
        RESET_BTN: 'export-reset-button',
        GENERATE_BTN: 'export-generate-button',
        SELECTABLE_COLUMNS: 'export-selectable-column',
        ALL_BTN: 'export-all-button',
        CLEAR_BTN: 'export-clear-button',
        RANGE: 'export-range',
    },
    PAGINATION_TID: {
        NEXT_BTN: 'pagination-next-button',
        PREV_BTN: 'pagination-prev-button',
        ROWS_PER_PAGE: 'pagination-rows-per-page',
        ROWS_PER_PAGE_OPTION: 'pagination-rows-per-page-option'
    },
    DATA_TABLE_CARD_TID: {
        /** Root wrapper of the mobile card list */
        CARD_LIST: 'data-table-card-list',
        /** Individual card row */
        CARD: 'data-table-card',
        /** Expand/collapse toggle at the bottom of each card */
        CARD_EXPAND_BTN: 'data-table-card-expand-btn',
        /** Expanded detail panel inside a card */
        CARD_EXPAND_PANEL: 'data-table-card-expand-panel',
        /** Sort pill chip for a column */
        SORT_CHIP: 'data-table-card-sort-chip',
        /** Sort bar container */
        SORT_BAR: 'data-table-card-sort-bar',
    }
}